/**
 * Link Fragment
 *
 * Common pattern for link objects used across multiple blocks.
 */

import { defineQuery } from 'next-sanity'

/**
 * Field projection for a link
 * Can be interpolated into block queries
 */
export const linkFields = `
  url,
  newTab
`

/**
 * Complete query for a single link
 * Note: Links are typically embedded, not queried separately
 * This is mainly for type generation reference
 */
export const LINK_QUERY = defineQuery(/* groq */ `
  *[_type == "link"][0]{
    ${linkFields}
  }
`)
